import {formatDate} from '../../../helpers/utils';

export const COMMON_REQ = 'cris/approveInspection/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/approveInspection/COMMON_REQ_FAIL';

export const LOAD_APPROVE_INSPECTIONS_REQ = 'cris/approveInspection/LOAD_APPROVE_INSPECTIONS_REQ';
export const SUBMIT_APPROVE_INSPECTIONS_REQ = 'cris/approveInspection/SUBMIT_APPROVE_INSPECTIONS_REQ';

const initialState = {
	isLoading: false,
	error: null,
	approveInspections: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_APPROVE_INSPECTIONS_REQ:
			const approveInspections = action.payload.data.inspections.map((item) => {
				let billHoursDetail = '';
				if(item.billed_hours.length) {
					const billHours = item.billed_hours.reduce((obj, billHour) => {

						let totalHour = 0;
						if(billHour.billable_item.type === 'Hourly') {
							totalHour = parseFloat(billHour.base_hour) + parseFloat(billHour.overtime_hour) + parseFloat(billHour.holiday_hour)
						} else if(billHour.billable_item.type === 'Fixed') {
							totalHour = parseFloat(billHour.unit_hour)
						}

						if(obj[billHour.billable_item.id]) {
							obj[billHour.billable_item.id].totalHour += totalHour;
						} else {
							obj[billHour.billable_item.id] = {
								name: billHour.billable_item.name,
								totalHour: totalHour
							}
						}

						return obj
					}, {});

					billHoursDetail = Object.keys(billHours).reduce((str, item, index) => {
						if(index === 0) {
							return str += billHours[item].name + ' - ' + billHours[item].totalHour;
						}

						return str += ', ' + billHours[item].name + ' - ' + billHours[item].totalHour;
					}, '');
				}

				return {
					id: item.id,
					date: item.date,
					formattedDate: formatDate(item.date),
					shift: item.shift,
					total_inspected: parseInt(item.total_inspected, 10),
					total_defect: parseInt(item.total_defect, 10),
					total_rework: parseInt(item.total_rework, 10),
					comment: item.comment || '',
					total_base_hour: parseFloat(item.total_base_hour),
					total_overtime_hour: parseFloat(item.total_overtime_hour),
					total_holiday_hour: parseFloat(item.total_holiday_hour),
					workOrderCode: item.work_order.code,
					workOrderOldCode: item.work_order.old_code || '',
					partNumber: item.part.number,
					billHoursDetail: billHoursDetail
				}
			});

			return {
				...state,
				isLoading: false,
				approveInspections: approveInspections
			};

		case SUBMIT_APPROVE_INSPECTIONS_REQ:
			const newApproveInspections = state.approveInspections.filter(item => item.id !== action.payload.id);

			return {
				...state,
				isLoading: false,
				approveInspections: newApproveInspections
			};

		default:
			return state;
	}
}